import { useMutation } from '@tanstack/react-query';
import { getConversations } from 'src/redux/slices/chat';
import { dispatch } from 'src/redux/store';
import { ChatRequests } from 'src/requests/chat';

export const useToggleConversation = () => {
  const { mutateAsync: toggleConversation, isLoading: isTogglingConversation } =
    useMutation({
      mutationFn: ChatRequests.toggleChatConversation,
      onSuccess: async () => {
        await dispatch(getConversations());
      },
    });

  return { toggleConversation, isTogglingConversation };
};
